import { SupportTicketStatusEnum } from '@/services/api-clients';

export function supportTicketStatusIconFilter(status: SupportTicketStatusEnum): string {
  switch (status) {
    case SupportTicketStatusEnum.Open: return 'mdi-message-alert-outline';
    case SupportTicketStatusEnum.InProgress: return 'mdi-timer-sand';
    case SupportTicketStatusEnum.Closed: return 'mdi-check-circle-outline';
    default: return 'mdi-help-circle-outline';
  }
}
